import RestService from '@tuva-ui/components/src/RestService';
import axios from 'axios';

class ModalAPI extends RestService {
  getRoles() {
    return axios
      .get(`/api/misc/roles/`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        return;
      });
  }

  saveRequestQuote(data) {
    return axios({
      method: 'Post',
      url: `/account/request-quote/`,
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
      },
      data: data,
    })
      .then(response => {
        return response;
      })
      .catch(error => ({ error }));
  }

  login(username, password) {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    return axios
      .post('/accounts/ajax-login/', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      .then(response => response.data)
      .catch(error => ({ error }));
  }

  register(userType, data) {
    const formData = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) formData.append(key, value);
    });
    return axios
      .post(`/accounts/register/new/${userType}/`, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      .then(response => response.data)
      .catch(error => ({ error }));
  }

  // Charges a Stripe token created by the payment page. Resolves to the
  // endpoint's { payment_status, message } body for both outcomes.
  charge(data) {
    return axios
      .post('/api/misc/payment/', data)
      .then(response => response.data)
      .catch(error => {
        if (error.response && error.response.data) {
          return error.response.data;
        }
        return {
          payment_status: 'failed',
          message: 'Failed! Please try again later!',
        };
      });
  }

  forgotPassword(email) {
    return axios
      .post('/api/misc/forget-password/', { email })
      .then(response => response.data)
      .catch(error => {
        if (error.response && error.response.data) {
          return { error: true, message: error.response.data.message };
        }
        return { error: true, message: 'Something went wrong.' };
      });
  }
}

const ModalService = new ModalAPI();
export default ModalService;
